import { Box, Flex, Grid, GridItem, Table, Text } from "@chakra-ui/react";
import { PersonaDetalle } from "../schema/person.schema";
import dayjs from "dayjs";
import "@/components/common/section-components/card/text-elements.css";
import { AppColors } from "@/styles/colors";
import { v4 } from "uuid";

interface Props {
  personData: PersonaDetalle | null;
}
export const PersonalData = ({ personData }: Props) => {
  return (
    <Flex flexDir="column">
      <Grid templateColumns="repeat(4, 1fr)" gap="6" paddingTop="20px">
        <GridItem>
          <Flex flexDir="column" divideY="1px" gap="5px">
            <Text className="person-title-label">Sexo</Text>

            <Text className="person-value-label" paddingTop="5px">
              {personData?.sexo ?? "-"}
            </Text>
          </Flex>
        </GridItem>
        <GridItem>
          <Flex flexDir="column" divideY="1px" gap="5px">
            <Text className="person-title-label">Fecha de nacimiento</Text>

            <Text className="person-value-label" paddingTop="5px">
              {personData?.nacimiento
                ? dayjs(personData?.nacimiento).format("DD/MM/YYYY")
                : "-"}
            </Text>
          </Flex>
        </GridItem>
        <GridItem>
          <Flex flexDir="column" divideY="1px" gap="5px">
            <Text className="person-title-label">Apodo</Text>

            <Text className="person-value-label" paddingTop="5px">
              {personData?.apodo ?? "-"}
            </Text>
          </Flex>
        </GridItem>
        <GridItem>
          <Flex flexDir="column" divideY="1px" gap="5px">
            <Text className="person-title-label">Localidad de residencia</Text>

            <Text className="person-value-label" paddingTop="5px">
              {personData?.localidad ?? "-"}
            </Text>
          </Flex>
        </GridItem>
      </Grid>

      <Grid templateColumns="repeat(4, 1fr)" gap="6" paddingTop="10px">
        <GridItem>
          <Flex flexDir="column" divideY="1px" gap="5px">
            <Text className="person-title-label">Actividad agropecuaria</Text>

            <Text className="person-value-label" paddingTop="5px">
              {personData?.esProductor ? "Sí" : "No"}
            </Text>
          </Flex>
        </GridItem>
        <GridItem>
          <Flex flexDir="column" divideY="1px" gap="5px">
            <Text className="person-title-label">Nivel de estudios</Text>

            <Text className="person-value-label" paddingTop="5px">
              {personData?.nivelEstudio?.nombre ?? "-"}
            </Text>
          </Flex>
        </GridItem>
        <GridItem>
          <Flex flexDir="column" divideY="1px" gap="5px">
            <Text className="person-title-label">Estado civil</Text>

            <Text className="person-value-label" paddingTop="5px">
              {personData?.estadoCivil?.nombre ?? "-"}
            </Text>
          </Flex>
        </GridItem>
        <GridItem>
          <Flex flexDir="column" divideY="1px" gap="5px">
            <Text className="person-title-label">Profesión</Text>

            <Text className="person-value-label" paddingTop="5px">
              {personData?.profesion?.nombre ?? "-"}
            </Text>
          </Flex>
        </GridItem>
      </Grid>

      <Box
        height="1px"
        backgroundColor={AppColors.WHITE_BORDER_1}
        marginTop="10px"
      />

      <Box paddingTop="12px" borderRadius="8px">
        <Table.ScrollArea
          css={{
            "@media (max-width: 1350px) and (min-width: 1272px)": {
              maxWidth: "900px",
              height: "100px",
            },
            "@media (max-width: 1414px) and (min-width: 1351px)": {
              maxWidth: "1100px",
              height: "175px",
            },
            "@media (max-width: 1590px) and (min-width: 1415px)": {
              maxWidth: "1250px",
              height: "210px",
            },
            "@media (max-width: 1696px) and (min-width: 1591px)": {
              maxWidth: "1350px",
              height: "250px",
            },
            "@media (max-width: 1900px)": {
              maxWidth: "1500px",
              height: "300px",
            },
            "@media (min-width: 1901px)": {
              height: "360px",
            },
          }}
        >
          <Table.Root
            size="sm"
            striped
            stickyHeader
            borderRadius="12px"
            border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          >
            <Table.Header>
              <Table.Row bgColor={AppColors.WHITE_BORDER_1}>
                <Table.ColumnHeader>
                  <Text
                    padding="16px"
                    color={AppColors.GRAY_TEXT}
                    fontWeight={700}
                    textTransform="uppercase"
                    fontSize="12px"
                  >
                    HOBBIES
                  </Text>
                </Table.ColumnHeader>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {personData?.hobbies?.length ? (
                <>
                  {personData?.hobbies?.map((hobby) => (
                    <Table.Row key={v4()}>
                      <Table.Cell>
                        <Text
                          padding="16px"
                          fontWeight={400}
                          fontSize="12px"
                          color={AppColors.BLACK_TEXT_SECONDARY}
                        >
                          {hobby?.nombre ?? "-"}
                        </Text>
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </>
              ) : (
                <Flex
                  alignItems="center"
                  flexDir="column"
                  justifyContent="center"
                  minHeight="45px"
                >
                  <Text
                    className="account-value-label"
                    fontWeight={600}
                    color={AppColors.GRAY_TEXT}
                  >
                    No hay datos disponibles
                  </Text>
                </Flex>
              )}
            </Table.Body>
          </Table.Root>
        </Table.ScrollArea>
      </Box>
    </Flex>
  );
};
